import { DiscountType } from "./discount"

export type CouponApiResponse = {
    code: string
    discountType: DiscountType
    discountValue: number
    id: string
    name: string
    usageLimit: number
    usagePerClient: number
}

export type CouponInput = {
    code: string
    discount_type?: DiscountType
    discount_value?: number
    name?: string
}

export type Coupon = {
    id: string
    code: string
}

export function calculateCouponTotalAmount(amount: number, coupon?: CouponApiResponse, valid_recurring_count: number = 1): number { // TODO: change to mapped type 
    let total_amount
    if (coupon) {
        let discounted_amount
        let discounted_count = (coupon.usagePerClient >= 1000000 ? coupon.usageLimit >= 1000000 ? valid_recurring_count : coupon.usageLimit : coupon.usagePerClient || 0)
        discounted_count = discounted_count > 0 ? discounted_count : valid_recurring_count

        if (coupon.discountType == DiscountType.PERCENT) {
            discounted_amount = amount - (amount * (coupon.discountValue / 100))
        } else {
            discounted_amount = amount - coupon.discountValue
        }

        total_amount = (discounted_amount * discounted_count) + (amount * (valid_recurring_count - discounted_count))
    } else {
        total_amount = amount * valid_recurring_count
    }
    total_amount = total_amount > 0 ? total_amount : 0
    return total_amount
}
